<template>
  <div id="app">
    <!-- 共通のヘッダーコンポーネント -->
    <Header />
    <flash-message ref="flashMsg" />

    <!-- ページコンテンツ -->
    <div class="container-area">
      <router-view />
    </div>

    <!-- 共通のフッターコンポーネント -->
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/shared/Header.vue"; // 共通のヘッダーコンポーネントをインポート
import FlashMessage from '@/components/shared/FlashMessage.vue';
import Footer from "@/components/shared/Footer.vue"; // 共通のフッターコンポーネントをインポート
import store from "@/store"; // Vuexストアをインポート

export default {
  name: "App",
  components: {
    Header,
    FlashMessage,
    Footer,
  },
  created() {
    this.checkLoginStatus();
  },
  methods: {
    checkLoginStatus() {
      const accessToken = localStorage.getItem('accessToken');
      if (accessToken) {
        store.dispatch('setLoggedIn', true);
        store.dispatch('setUserName', localStorage.getItem('userName'));
        store.dispatch('setUserRole', localStorage.getItem('userRole'));
      }
    }
  }
};
</script>

<style>
:root{
  --app-header-offset: 70px;
  --app-footer-height: 48px;
  --app-page-bottom-space: 24px;
}

html{
  min-height: 100%;
}
body{
  min-height: 100%;
  margin: 0;
}
#app{
  min-height: 100vh;
}
.container-area{
  width: 96%;
  min-height: calc(100vh - var(--app-header-offset));
  margin: var(--app-header-offset) auto 0;
  padding: 24px 0 calc(var(--app-footer-height) + var(--app-page-bottom-space));
  box-sizing: border-box;
}

/* 一覧の大枠 */
.list-container {
  width: 100%;
  min-height: 100%;
  padding: 20px;
  box-sizing: border-box;
}

/* タイトル */
.page-title{
  padding-left: 12px;
  margin-bottom: 12px;
  font-size: 32px;
  font-weight: bold;
  border-left: 8px solid #023259;
}

.search-container{
  font-size: 14px;
}
.search-container input[type="text"],
.search-container input[type="date"],
.search-container input[type="number"],
.search-container select {
  font-size: 14px;
}

/* マスタ一覧のテーブル */
.master-table{
  font-size: 14px;
}
.master-table thead th {
  position: sticky;
  top: 0;
  background: #003366 !important;
  color: #fff !important;
  border: 1px solid #dee2e6;
  z-index: 55;
}
.master-table thead th::before {
  content: "";
  position: absolute;
  top: -1px;
  left: -1px;
  width: 1px;
  height: 1px;
  background: #dee2e6 !important;
}
.master-table thead th::after {
  content: "";
  position: absolute;
  bottom: -1px;
  right: -1px;
  width: 1px;
  height: 1px;
  background: #dee2e6 !important;
}

/* テーブル */
.table-wrapper{
  width: 100%;
  overflow-x: scroll;
  background: #bbbbbb;
  border: 1px solid #bbbbbb;
  transition: max-height 0.3s ease;
}

.multiline-text {
  white-space: pre;
}
</style>
